module.exports = __webpack_public_path__ + "img/icon-sort-up.9a4716ed.svg";